import { useNavigate, useSearchParams } from 'react-router';
import { X } from 'lucide-react';

import { useSoftwareEscrowOnboarding } from 'src/context/software-escrow';
import { SoftwareOnboardingHeader, SoftwareOnboardingProgress } from 'src/components/SoftwareOnboarding';
import { Button } from 'src/components/ui/button';
import { useLocalStorage } from 'src/hooks';
import { SOFTWARE_ESCROWS_FILTER_STORAGE_KEY } from 'src/shared/constants';

const Header = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { totalSteps, currentStep, lastCompletedStep } = useSoftwareEscrowOnboarding();
  const [savedStatus] = useLocalStorage(SOFTWARE_ESCROWS_FILTER_STORAGE_KEY, '');

  const isEdit = searchParams.get('isEdit') === 'true';
  if (isEdit) return null;

  // On close, navigate to the dashboard with the saved filters if there are any
  const onClose = () => navigate(savedStatus ? `/software-escrows?t=${savedStatus}` : '/software-escrows');

  return (
    <SoftwareOnboardingHeader>
      <SoftwareOnboardingProgress currentStep={currentStep} totalSteps={totalSteps} completedStep={lastCompletedStep} />
      <Button variant="ghost" size="icon" className="size-6 -mt-1.5" onClick={onClose}>
        <X />
      </Button>
    </SoftwareOnboardingHeader>
  );
};

export default Header;
